import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';

@Component({
  selector: 'app-otpnotreceived',
  templateUrl: './otpnotreceived-modal.component.html',
  styleUrls: ['./otpnotreceived-modal.component.scss'],
})
export class OtpnotreceivedModalComponent {
  @Input() isDisableResendBtn: boolean = false;
  // #region INPUT, OUTPUT, VIEWCHILD
  @Output() onResendOTP = new EventEmitter<any>();
  @ViewChild('otpNotReceivedModal')
  otpNotRecievedTemplate!: TemplateRef<OtpnotreceivedModalComponent>;

  // #endregion
  email: string = '';

  constructor(private authService: AuthService) {}

  onResendOTPClick() {
    this.isDisableResendBtn = true;
    this.onResendOTP.emit();
  }

  enterKeyPress(event) {
    /** Note - keycode 13 mining Enter key */
    if (event.keyCode === 13) {
      this.onResendOTPClick();
    }
  }
}
